import React, { useEffect, useState } from "react";
import { Tab } from "@headlessui/react";
import Analytics from "./Analytics";
import ChatLogs from "./ChatLogs";
import { ChatbotContext } from "../../TabContextProvider";
import loader from "../../../../methods/loader";
import methodModel from "../../../../methods/methods";
import { useSelector } from "react-redux";

const Index = () => {
  const [selectedIndex, setSelectedIndex] = useState(0);

  const allTabs = [
    {
      name: "Analytics",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 3v16a2 2 0 0 0 2 2h16" />
          <path d="M18 17V9" />
          <path d="M13 17V5" />
          <path d="M8 17v-3" />
        </svg>
      ),
      component: <Analytics />,
    },
    {
      name: "Chat Logs",
      icon: (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      ),
      component: <ChatLogs />,
    },
  ];

  return (
    <Tab.Group selectedIndex={selectedIndex} onChange={setSelectedIndex}>
      {/* Tab List */}
      <div className="border rounded-t-2xl bg-gray-50 px-5">
        <div className="overflow-auto">
          <Tab.List className="flex gap-2">
            {allTabs.map((tab, index) => (
              <Tab
                key={index}
                className="flex items-center gap-2 py-3 sm:py-4 px-3 sm:px-6 text-sm sm:text-md text-gray-600 tracking-[0.2px] whitespace-nowrap leading-none border-b-2 border-transparent aria-selected:border-b-2 aria-selected:border-[#115B9D] hover:border-b-2 hover:border-gray-300 aria-selected:text-[#115B9D] outline-none capitalize"
              >
                {tab.icon ?? null}
                {tab.name}
              </Tab>
            ))}
          </Tab.List>
        </div>
      </div>

      {/* Tab Panels */}
      <div className="w-full border border-t-0 rounded-b-2xl bg-white p-5 lg:p-8">
        <Tab.Panels>
          {allTabs.map((tab, index) => (
            <Tab.Panel key={index}>
              {typeof tab.component === "function" ? tab.component() : tab.component}
            </Tab.Panel>
          ))}
        </Tab.Panels>
      </div>
    </Tab.Group>
  );
};

export default Index;